// @flow

import { useTranslator } from '@gandi/translate';
import { Button, Svg } from '@gandi/ui';

import { Breadcrumb, type BreadCrumbProps } from '../Breadcrumb/Breadcrumb';

import styles from './FunnelControls.scss';

type Props = {
  currentStep: BreadCrumbProps['currentStep'],
};

export function FunnelControls({ currentStep }: Props): React.MixedElement {
  const { __ } = useTranslator();
  return (
    <>
      <Button to="/" className={styles.logoContainer}>
        <Svg
          // needed for the display title
          id="gandi-net-logo"
          name="gandiIcon"
          theme="neutral-strong"
          title={__('Return to homepage')}
          className={styles.logo}
        />
      </Button>
      <Breadcrumb currentStep={currentStep} />
    </>
  );
}
